import { ProductDTO } from './product';
import { GenericConfig } from '@signature-it/ngx-generic/config';

export class CngProductDTO extends ProductDTO  {
    cngProductId: number;
    type: string;
	cngAddToBasketType: string;
	productTemplate: string;
	productDescription: string;

    constructor(attributes?: Object) {
        attributes = attributes ? attributes : {};
        super(attributes);
        this.cngProductId = attributes['cngProductId'] || -1;
        this.type = 'cng product';
        this.cngAddToBasketType = attributes['cng_add_to_basket_type_s'] || 'single';
        this.ProductName = attributes[GenericConfig.productCardMainTitleField];
        this.productDescription = attributes[GenericConfig.productCardSecondaryTitleField] || attributes[GenericConfig.productCardMainTitleField];
		this.productTemplate = attributes['product_template_s'] || "";
	}

}
